import Raven from "raven-js";
if (window.sentry_settings) {
  Raven.config(
    window.sentry_settings.public_dsn,
    window.sentry_settings.options
  ).install();
}



// WEBPACK FOOTER //
// ./js/raven.js